import { ReactNode } from 'react';
import type User from '@alltrails/core/types/User';
import CarouselDisplayTrigger from '@alltrails/amplitude/enums/CarouselDisplayTrigger';
import UpsellTrigger from '@alltrails/amplitude/enums/UpsellTrigger';
import type DeeplinkData from '@alltrails/types/DeeplinkData';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import useIsIos from '@alltrails/core/hooks/useIsIos';
import useV6InterstitialLogic from '@alltrails/install-prompt/hooks/useV6InterstitialLogic';
import SignUpModal from './SignUpModal';
import SignUpModalWithApp from './SignUpModalWithApp';

type Props = {
  autoClose?: boolean;
  closeModal: (event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent) => void;
  deeplinkData?: DeeplinkData;
  heading?: ReactNode;
  hideInstallPrompt?: boolean;
  isOpen: boolean;
  onSuccess: (user: User) => void;
  redirectUrl?: string;
  hideUpsell?: boolean;
  trigger: CarouselDisplayTrigger;
  upsellTrigger: UpsellTrigger;
};

export default function SignUpModalWrapper({
  autoClose,
  closeModal,
  deeplinkData,
  heading,
  hideInstallPrompt = false,
  isOpen,
  onSuccess,
  redirectUrl,
  hideUpsell = false, // changed from showUpsell = true
  trigger,
  upsellTrigger
}: Props) {
  const isMobile = useIsMobileSizedScreen();
  const isIos = useIsIos();
  const { shouldSuppressInterstitialForAndroid } = useV6InterstitialLogic();

  const isSignupWithApp = (isMobile && isIos) || (isMobile && shouldSuppressInterstitialForAndroid);

  if (isSignupWithApp) {
    return (
      <SignUpModalWithApp
        autoClose={autoClose}
        closeModal={closeModal}
        deeplinkData={deeplinkData}
        heading={heading}
        isOpen={isOpen}
        onSuccess={onSuccess}
        redirectUrl={redirectUrl}
        trigger={trigger}
        upsellTrigger={upsellTrigger}
      />
    );
  }

  return (
    <SignUpModal
      autoClose={autoClose}
      closeModal={closeModal}
      heading={heading}
      hideInstallPrompt={hideInstallPrompt}
      isOpen={isOpen}
      onSuccess={onSuccess}
      redirectUrl={redirectUrl}
      hideUpsell={hideUpsell}
      trigger={trigger}
      deeplinkData={deeplinkData}
      upsellTrigger={upsellTrigger}
    />
  );
}
